'use client';

import styles from './alphabet-filters.module.scss';
import alphabet from './alphabet';
import PropTypes from 'prop-types';
import { useState } from 'react';
import LetterFilter from 'components/letter-filter';

const AlphabetFilters = ({
	availableLetters,
	onChange,
	defaultSelected = null,
}) => {
	const [selected, setSelected] = useState(defaultSelected);

	const handleChange = (e) => {
		if (e.target.checked) {
			setSelected(e.target.value);
		} else {
			setSelected(null);
		}
		onChange(e);
	};

	return (
		<fieldset className={styles.alphabetFilters}>
			<legend className={styles.legend}>Filter alphabetically</legend>
			<div className={styles.filters}>
				{alphabet.map((letter) => {
					const id = `alphabet-filter-${letter}`;
					return (
						<LetterFilter
							checked={letter === selected}
							disabled={!availableLetters.includes(letter)}
							handleChange={handleChange}
							id={id}
							key={letter}
							letter={letter}
						/>
					);
				})}
			</div>
		</fieldset>
	);
};

AlphabetFilters.propTypes = {
	availableLetters: PropTypes.arrayOf(PropTypes.string).isRequired,
	onChange: PropTypes.func.isRequired,
	defaultSelected: PropTypes.any,
};

export default AlphabetFilters;
